module.exports = __webpack_public_path__ + "assets/ccce27760ace88bb8b7e792a1cc6b8f3.mp3";